import * as React from 'react';
import { Link } from 'react-router-dom';
import strings from '../../strings/strings.json';
import Button from '../../components/buttons/Button';
import { IconSize } from '../../assets/icons/icon-sizes';
import CloseIcon from '../../assets/icons/controls/CloseIcon';
import { StyledNeveLogo, LimitedContainer, NavigationContainer, NavigationLogoSection } from './Navigation';
import styled from 'styled-components';
import { breakpoints, sizes } from 'theme';
import { AuthContext } from 'contextProviders/AuthContext';
import { useContext } from 'react';
import { DOCUMENTS_URL } from 'lib/_api-helpers';
import { FlexAlignCenter } from 'components/Elements';

type NavigationSlimProps = {
    buttonTitle: string;
    buttonAria: string;
    buttonOnClick: () => void;
};

export function NavigationSlim({ buttonTitle, buttonAria, buttonOnClick }: NavigationSlimProps): JSX.Element {
    const { userData } = useContext(AuthContext);

    return (
        <Container id={'nav'}>
            <LimitedContainerSlim>
                <NavigationLogoSectionSlim>
                    {userData.organisation?.logoS3Filepath ? (
                        <Link to={'/'}>
                            <Image
                                src={`${DOCUMENTS_URL}/${userData.organisation.logoS3Filepath}`}
                                alt={`${userData.organisation.name} logo`}
                                aria-label={strings.appHeader.neveLearningLogoAria}
                            />
                        </Link>
                    ) : (
                        <Link to={'/'}>
                            <StyledNeveLogo
                                alt={strings.appHeader.neveLearningLogoAltText}
                                aria-label={strings.appHeader.neveLearningLogoAria}
                            />
                        </Link>
                    )}
                </NavigationLogoSectionSlim>
                <FlexAlignCenter>
                    <Button
                        title={buttonTitle}
                        aria={buttonAria}
                        icon={<CloseIcon size={IconSize.SMALL} />}
                        onClick={buttonOnClick}
                    />
                </FlexAlignCenter>
            </LimitedContainerSlim>
        </Container>
    );
}

const Container = styled(NavigationContainer)`
    padding: 0 ${sizes.edgePadding};
    @media (max-width: ${breakpoints.sm}) {
        height: ${sizes.headerHeight};
        padding: ${sizes.edgePadding} 10px;
    }
`;

const LimitedContainerSlim = styled(LimitedContainer)`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const NavigationLogoSectionSlim = styled(NavigationLogoSection)`
    @media (max-width: ${breakpoints.sm}) {
        border-bottom: unset;
        padding: unset;
    }
`;

const Image = styled.img`
    border-radius: ${sizes.borderRadiusMd};
    width: auto;
    max-height: 45px;
`;
